'use client';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import { BlogWithCategory } from '@/Types/BlogTypes';
import BlogCard from '../cards/BlogCard';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

interface BlogSliderProps {
    blogs: BlogWithCategory[];
}

export default function BlogSlider({ blogs }: BlogSliderProps) {
    return (
        <div className="w-full relative">
            <Swiper
                modules={[Navigation, Pagination, Autoplay]}
                spaceBetween={24}
                slidesPerView={1}
                navigation
                pagination={{ clickable: true }}
                autoplay={{
                    delay: 5000,
                    disableOnInteraction: false,
                }}
                breakpoints={{
                    640: {
                        slidesPerView: 2,
                        spaceBetween: 20,
                    },
                    1024: {
                        slidesPerView: 3,
                        spaceBetween: 24,
                    },
                }}
                className="blog-swiper"
            >
                {blogs.map((blog) => (
                    <SwiperSlide key={blog._id}>
                        <BlogCard blog={blog} />
                    </SwiperSlide>
                ))}
            </Swiper>

            <style jsx global>{`
                .blog-swiper {
                    padding-bottom: 50px;
                }

                .blog-swiper .swiper-button-next,
                .blog-swiper .swiper-button-prev {
                    color: #000;
                    background: white;
                    width: 40px;
                    height: 40px;
                    border-radius: 50%;
                    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
                }

                .blog-swiper .swiper-button-next:after,
                .blog-swiper .swiper-button-prev:after {
                    font-size: 16px;
                    font-weight: bold;
                }

                .blog-swiper .swiper-pagination-bullet {
                    background: #000;
                    opacity: 0.3;
                }

                .blog-swiper .swiper-pagination-bullet-active {
                    opacity: 1;
                }
            `}</style>
        </div>
    );
}